import { selectRequestByType } from 'ducks/requests/selectors'
import { FETCH_BILLING_DATA_V2 } from '../types'

export const selectFetchBillingDataV2Request = state => {
  return selectRequestByType(state, FETCH_BILLING_DATA_V2)
}
